<template>
  <div class="container">
    <Header @getTwotree="getTwotree" @getRouter="getRouter" @getThreetree="getThreetree"/>
    <div v-show="!centent && !centent2" class="max"><router-view /></div>
    <div v-show="centent"  v-if="centent1" v-html="two" class="tree"></div>
    <div v-show="centent2"  v-if="centent3" v-html="lastTree" class="tree"></div>
    <Footer />
  </div>
</template>

<script>
import Header from './commponents/Header.vue'
import Footer from './commponents/Footer.vue'
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      two: null,
      centent: false,
      centent1: true,
      centent2: false,
      centent3: true,
      lastTree: null
    }
  },
  methods: {
    // 三级树的页面
    getThreetree(val) {
      this.lastTree = val // 获取后端的html标签
      this.centent2 = true
      this.centent = false
      this.centent3 = val
    },
    // 二级树的页面
    getTwotree(val) {
      this.two = val // 获取后端的html标签
      this.centent = true
      this.centent2 = false
      this.centent1 = val
    },
    // 一级树的跳转
    getRouter(data, url) {
      if (url) {
        return window.open(url)
      } else if (data) {
        this.$router.push({ name: data })
      } else {
        this.$router.push({ name: '公司首页', path: '/index' })
      }
      this.centent = false
      this.centent2 = false
    }
  },
  watch: {
    '$route' (to, from) {
      // 对路由变化作出响应...
      // console.log('to.path----', to.name)// 跳转后路由
      // console.log('from----', from.path)// 跳转前路由
      this.getRouter(to.name)
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  height: 100%;
  background-color: #122a46;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  // @media screen and (max-width: 375px) {
  //   max-width: 375px;
  // }
  .footer {
    flex: 0 0 150px;
    // @media screen and (max-width: 375px) {
    //   // flex: 0 0 200px;
    // }
  }
  .max {
    // flex: 1;
  }
  .tree {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    padding: 100px 0 300px 0;
    color: aliceblue;
    background-color: #122a46;
    // background: linear-gradient(to right, #6495ED 0%,#112945  20%, #112945  50%,#112945  85%, #6495ED 100%);
    @media screen and (max-width: 1200px) {
      padding: 200px 0 300px 0;
    }
    @media screen and (min-width: 1200px) {
      padding: 200px 0 300px 0;
    }
    /deep/h1 {
      font-size: 40px;
      color: #fff;
      line-height: 24px;
      font-weight: 700;
    }
    /deep/ h3 {
      @media screen and (max-width: 1200px) {
        display: block;
        width: 90%;
        line-height: 60px;
      }
    }
    /deep/h4 {
      font-size: 20px;
      font-weight: 700;
      line-height: 24px;
      margin-top: 10px;
      display: -webkit-box;
      -webkit-box-orient: vertical; /*设置方向*/
      -webkit-line-clamp: 1; /*设置超过为省略号的行数*/
      overflow: hidden;
    }
    /deep/img {
      width: 65vw;
    }
  }
}
</style>
